import React from 'react';

import LayoutTree from 'app/app/editor/tabs/elements/layout/LayoutTree';
import SettingsTab from 'app/app/editor/tabs/settings/SettingsTab';
import { alpha, Stack, Box } from '@mui/material';
import { Resizable } from 're-resizable';

export default function ElementsTab({ componentUid }: { componentUid: string | null }) {
    return (
        <Stack height={1}>
            <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                <LayoutTree componentUid={componentUid} />
            </Box>
            <Resizable
                defaultSize={{
                    width: '100%',
                    height: '60%',
                }}
                className={'app-builder__right-panel-container'}
                minHeight={'20%'}
                maxHeight={'80%'}
                onResizeStart={(event, direction, elementRef) => {
                    elementRef.classList.add('resizing-settings-active');
                }}
                onResizeStop={(event, direction, elementRef, delta) => {
                    elementRef.classList.remove('resizing-settings-active');
                }}
                handleComponent={{
                    top: (
                        <Stack
                            sx={{
                                position: 'relative',
                                overflow: 'hidden',
                                height: '100%',
                                width: '100%',
                                flexShrink: 0,
                                borderBottom: '1px solid',
                                borderColor: 'transparent',
                                transition: 'all 0s ease-in-out .1s',
                                '&:hover, .resizing-settings-active &': {
                                    borderColor: (theme) => theme.palette.primary.main,
                                    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
                                },
                            }}
                        />
                    ),
                }}
                handleStyles={{
                    top: {
                        top: '-3px',
                        width: '100%',
                        height: '3px',
                        zIndex: 1,
                    },
                }}
                enable={{
                    top: true,
                    right: false,
                    bottom: false,
                    left: false,
                    topRight: false,
                    bottomRight: false,
                    bottomLeft: false,
                    topLeft: false,
                }}
            >
                <Box sx={{ height: '100%' }}>
                    <SettingsTab componentUid={componentUid} key={componentUid} />
                </Box>
            </Resizable>
        </Stack>
    );
}
